import { useCallback, useMemo } from 'react';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import resumeVideoLinkButtonClick, {
    HhtmSource,
} from '@hh.ru/analytics-js-events/build/xhh/employer/resume/resume_video_link_button_click';
import resumeVideoLinkElementShown from '@hh.ru/analytics-js-events/build/xhh/employer/resume/resume_video_link_element_shown';
import { Action } from '@hh.ru/magritte-ui';
import { PlayFilledSize16, PlayFilledSize24 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

import styles from './styles.less';

const TrlKeys = {
    altText: 'resume.video.link',
};

interface Props {
    /** Идентификатор резюме */
    resumeId: string;

    /** Ссылка на видео */
    videoLink: string;

    /** Мобильный экран */
    isMobile?: boolean;
}

/**
 * Кнопка открытия видео с самопрезентацией на карточке резюме поиска.
 */
const ResumeVideoLink: TranslatedComponent<Props> = ({ resumeId, videoLink, isMobile, trls }) => {
    const hhtmSource = useSelector((state) => state.analyticsParams.hhtmSource);
    const analyticsData = useMemo(
        () => ({ hhtmSource: hhtmSource as HhtmSource, resumeId: Number(resumeId) }),
        [hhtmSource, resumeId]
    );
    const sendVideoClickAnalytics = useCallback(() => resumeVideoLinkButtonClick(analyticsData), [analyticsData]);

    const handleClick = useCallback(() => {
        sendVideoClickAnalytics();
        window.open(videoLink, '_blank', 'noopener');
    }, [sendVideoClickAnalytics, videoLink]);

    return (
        <ElementShownAnchor
            fn={resumeVideoLinkElementShown}
            {...analyticsData}
            className={isMobile ? styles.videoLinkMobile : styles.videoLinkDesktop}
            data-qa="resume-card-video-link"
        >
            <Action
                showBackground
                style="accent"
                icon={isMobile ? PlayFilledSize24 : PlayFilledSize16}
                onClick={handleClick}
                aria-label={trls[TrlKeys.altText]}
            />
        </ElementShownAnchor>
    );
};

export default translation(ResumeVideoLink);
